import { get } from "lodash";
import { useLazyQuery, useMutation } from "shared/hooks/useApi";
import { UPDATE_SUBSCRIPTION } from "utils/api/graphql/mutations/subscription";
import { SUBSCRIPTION } from "utils/api/graphql/queries/subscription";
import { withDocumentsCompletion } from "./documentsCompletion";

const useSaveDocumentsCompletion = (subscriptionId) => {
  const [getSubscription] = useLazyQuery(SUBSCRIPTION, {
    fetchPolicy: "network-only",
  });
  const [updateSubscription] = useMutation(UPDATE_SUBSCRIPTION, {
    onError: () => {},
  });

  return async (isDocumentsCompleted) => {
    try {
      const { data } = await getSubscription({
        variables: { where: { id: subscriptionId } },
      });
      const subscription = get(data, "subscription");
      if (!subscription) return;
      const additionalInfo = withDocumentsCompletion(
        get(subscription, "additionalInfo"),
        isDocumentsCompleted,
      );
      await updateSubscription({
        variables: {
          where: { id: subscriptionId },
          data: { additionalInfo },
        },
      });
    } catch (_error) {
      // A completion flag failure must not block the prospect: the dossier
      // still reaches "signed incomplete" and the advisor is notified.
    }
  };
};

export default useSaveDocumentsCompletion;
